export default "/_next/static/images/dog5-5f45dba614bdd556ac867a018529583a.png";